import { PluginRuntime } from "@markedesk/plugin-sdk/ui";
import * as MaterialUI from "@material-ui/core";
import * as MaterialIcons from "@material-ui/icons";

/**
 * Carregamento sob demanda do @babel/standalone — só baixa quando um plugin usa
 * JSX (slot.mountJsx / openModal({ jsx })). Não incha o bundle do app. Servido
 * LOCALMENTE (public/vendor/babel.min.js), cacheado pelo browser; fallback ao
 * CDN. Cacheia a Promise (carrega 1x por sessão). window.Babel fica global.
 */
const BABEL_LOCAL = "/vendor/babel.min.js";
const BABEL_CDN = "https://unpkg.com/@babel/standalone@7/babel.min.js";
let babelPromise = null;

function injectScript(src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => resolve(window.Babel);
    s.onerror = () => reject(new Error("Falha ao carregar " + src));
    document.head.appendChild(s);
  });
}

export function loadBabel() {
  if (window.Babel) return Promise.resolve(window.Babel);
  if (babelPromise) return babelPromise;
  babelPromise = injectScript(BABEL_LOCAL)
    .catch(() => injectScript(BABEL_CDN))
    .catch((e) => { babelPromise = null; throw e; });
  return babelPromise;
}

/**
 * Transpila (Babel) e renderiza JSX de plugin num nó DOM, com o React DO APP
 * (mesma instância — hooks/context funcionam). `jsx` é o corpo de
 * `(React, props) => <JSX/>`. Compila 1x por string (cache no `cache`), pra o
 * React preservar estado/effects entre re-renders. Retorna um objeto com
 * `render(props)` e `unmount()`.
 */
export async function mountPluginJsx(node, jsx, initialProps, cache) {
  const Babel = await loadBabel();
  const React = PluginRuntime.react;
  const ReactDOM = PluginRuntime.reactDOM;
  if (!Babel || !React || !ReactDOM || !node) return null;

  const store = cache || {};
  if (!store.fns) store.fns = {};
  if (!store.fns[jsx]) {
    const { code } = Babel.transform("(function(React, props){ " + jsx + " })", { presets: ["react"] });
    // eslint-disable-next-line no-eval
    store.fns[jsx] = (0, eval)(code);
  }
  // Componente estável (criado 1x) que delega ao fn compilado — o React
  // reconcilia e preserva useState/useEffect entre renders.
  if (!store.comp) store.comp = (p) => store.fns[store.key](React, p);
  store.key = jsx;

  // Props que TODO JSX de plugin recebe, seja qual for o host (modal,
  // slot.mountJsx, campo de settings, resultado de action). Eram injetadas
  // host a host, e só um deles fazia: o modal e o slot entregavam o JSX sem
  // `mui`, e o plugin caía em `props.mui is undefined` — só no navegador, com
  // o modal já aberto (echo, 10-09-2026). No motor vale para todos de uma vez.
  //
  // Entra aqui só o que serve a qualquer plugin sem depender do que ele faz:
  //   React, mui, icons — desenhar com a cara do app, sem bundle próprio;
  //   idioma            — o core não traduz o texto do plugin, mas diz a língua;
  //   runtime           — api autenticada, socket, empresa, usuário, conexões.
  // O tradutor (`t`) NÃO entra: exige saber qual plugin é, e o motor não sabe —
  // os hosts que sabem (resultado de action) seguem entregando.
  // Vem antes das props do chamador de propósito: quem quiser sobrescrever pode.
  const render = (props) =>
    ReactDOM.render(
      React.createElement(store.comp, {
        React,
        mui: MaterialUI,
        icons: MaterialIcons,
        idioma: PluginRuntime.idioma || "pt",
        runtime: PluginRuntime,
        ...(props || {}),
      }),
      node
    );
  render(initialProps);
  return {
    render,
    unmount: () => { try { ReactDOM.unmountComponentAtNode(node); } catch (e) { /* noop */ } },
  };
}
